module.exports = {
	hamburgerMenu: function() {
		$('.hamburger').on('click',function(){
			$('.header').toggleClass('open');
		});
	},
	currentPage: function() {
		var page = $('.navMenu a');
		page.each(function(){
			var $href = $(this).attr('href');
			if (location.href.match($href)) {
				$(this).parent().addClass('current');
			} else {
				$(this).parent().removeClass('current');
			}
		});
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/resources/js/modules/header.js
// module id = 4
// module chunks = 0